var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWork(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#000000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2005 4672 c-120 -42 -205 -117 -258 -230 -31 -64 -32 -73 -37 -227 l-5 -160 -625 -5 -625 -5 -67 -26 c-144 -56 -262 -164 -328 -301 -54 -111 -61 -171 -58 -477 l3 -264 1278 -426 1277 -426 1278 426 1277 426 3 264 c3 304 -4 360 -57 474 -65 138 -183 247 -329 304 l-67 26 -625 5 -625 5 -5 161 -5 160 -37 75 c-46 93 -112 158 -206 202 l-67 32 -520 2 c-473 2 -524 1 -570 -15z m980 -512 l0 -105 -425 0 -425 0 -3 94 c-1 52 0 101 2 108 5 11 83 13 428 11 l423 -3 0 -105z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 1799 c0 -936 -1 -918 66 -1050 49 -98 163 -213 254 -257 137 -66 -24 -62 2240 -62 2264 0 2103 -4 2240 62 99 48 209 162 259 269 22 46 44 111 50 143 17 91 15 1740 -1 1734 -7 -3 -564 -189 -1238 -413 l-1225 -409 -85 0 -85 0 -1225 409 c-674 224 -1231 410 -1237 413 -10 3 -13 -169 -13 -839z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWork);
export default __webpack_public_path__ + "static/media/work.882163fe426ada068d2bf7b4003b967e.svg";
export { ForwardRef as ReactComponent };